import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  deleteInstagramDisconnect,
  deleteWhatsappDisconnect,
  getAppointmentHistoryByClient,
  getCheckAddress,
  getClientExcelFile,
  getClientLabels,
  getClients,
  getClientView,
  getClientViewHeader,
  getClientViewReviews,
  getIndustry,
  getProfessionCategories,
  getLocation,
  getLogout,
  getProfileAnalytics,
  getRateApp,
  getServiceAdvancedSettings,
  getServiceBrandGet,
  getServiceExcelFile,
  getSocialProfile,
  getStories,
  getUserCurrency,
  getUserInfoWebsite,
  getUserView,
  postServiceAdvancedUploadImages,
} from "../../../api/profile/profileServices";
import { IAdvancesImages } from "../../../api/profile/profileModels";
import { getUserEmail } from "../../../api/auth/authServices";
import { ILocationResponse } from "./types";

export const getIndustryThunk = createAsyncThunk(
  "profile/getIndustry",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getIndustry();
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  },
);
export const getProfessionCategoriesThunk = createAsyncThunk(
  "profile/getProfessionCategories",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getProfessionCategories();
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  },
);

export const getClientsThunk = createAsyncThunk(
  "profile/getClients",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getClients();
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  },
);
export const getClientsLabelsThunk = createAsyncThunk(
  "profile/getClientsLabels",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getClientLabels();
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  },
);

export const getClientViewThunk = createAsyncThunk(
  "profile/getClientView",
  async (id: number, { rejectWithValue }) => {
    try {
      const response = await getClientView(id);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  },
);
export const getAppointmentHistoryByClientThunk = createAsyncThunk(
  "profile/getAppointmentHistoryByClient",
  async (id: number, { rejectWithValue }) => {
    try {
      const response = await getAppointmentHistoryByClient(id);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  },
);

export const getRateAppThunk = createAsyncThunk(
  "profile/getRateApp",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getRateApp();
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  },
);
export const getUserCurrencyThunk = createAsyncThunk(
  "profile/getUserCurrency",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getUserCurrency();
      return response.data.currency;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  },
);
export const getUserEmailThunk = createAsyncThunk(
  "profile/getUserEmail",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getUserEmail();
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  },
);
export const getClientViewHeaderThunk = createAsyncThunk(
  "profile/getClientViewHeader",
  async (id: number, { rejectWithValue }) => {
    try {
      const response = await getClientViewHeader(id);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  },
);
export const getClientViewReviewsThunk = createAsyncThunk(
  "profile/getClientViewReviews",
  async (id: number, { rejectWithValue }) => {
    try {
      const response = await getClientViewReviews(id);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  },
);

export const getProfileAnalyticsThunk = createAsyncThunk(
  "profile/getProfileAnalytics",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getProfileAnalytics();
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  },
);

export const getUserViewThunk = createAsyncThunk(
  "profile/getUserView",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getUserView();
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  },
);
export const getStoriesThunk = createAsyncThunk(
  "profile/getStories",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getStories();
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  },
);
export const getLocationThunk = createAsyncThunk<ILocationResponse | null>(
  "profile/getLocation",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getLocation();
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  },
);
export const getCheckAddressThunk = createAsyncThunk(
  "profile/getCheckAddress",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getCheckAddress();
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  },
);

export const getSocialProfileThunk = createAsyncThunk(
  "profile/getSocialProfile",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getSocialProfile();
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  },
);
export const getUserInfoWebsiteThunk = createAsyncThunk(
  "profile/getUserInfoWebsite",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getUserInfoWebsite();
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  },
);
export const getLogoutThunk = createAsyncThunk(
  "profile/getLogout",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getLogout();
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  },
);
export const getClientExcelFileThunk = createAsyncThunk(
  "profile/getClientExcelFile",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getClientExcelFile();
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  },
);
export const getServiceExcelFileThunk = createAsyncThunk(
  "profile/getServiceExcelFile",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getServiceExcelFile();
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  },
);
export const deleteInstagramDisconnectThunk = createAsyncThunk(
  "profile/deleteInstagramDisconnect",
  async (_, { rejectWithValue }) => {
    try {
      const response = await deleteInstagramDisconnect();
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  },
);
export const deleteWhatsappDisconnectThunk = createAsyncThunk(
  "profile/deleteWhatsappDisconnect",
  async (_, { rejectWithValue }) => {
    try {
      const response = await deleteWhatsappDisconnect();
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  },
);

export const getServiceAdvancedSettingsThunk = createAsyncThunk(
  "profile/getServiceAdvancedSettings",
  async (id: number, { rejectWithValue }) => {
    try {
      const response = await getServiceAdvancedSettings(id);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  },
);

export const getServiceBrandGetThunk = createAsyncThunk(
  "profile/getServiceBrandGet",
  async (id: number | undefined, { rejectWithValue }) => {
    try {
      const response = await getServiceBrandGet(id);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  },
);

export const postServiceAdvancedUploadImagesThunk = createAsyncThunk(
  "profile/postServiceAdvancedUploadImages",
  async (data: IAdvancesImages, { rejectWithValue }) => {
    try {
      const response = await postServiceAdvancedUploadImages(data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  },
);
